module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":["calendarUtils"],"commonjs":"calendar-utils","commonjs2":"calendar-utils","amd":"calendar-utils"}
// module id = 1
// module chunks = 0